import React from 'react';
import { SupportCardContent } from '../details/SupportCard';
import { EXTERNAL_LINKS, TAB_TYPE_CLAIMS_AND_RETURNS } from '../../constants';
import styled from '../../../../theme/styled';
import { mq } from '../../../../commons/styles';

const SupportCenterContainer = styled.div`
  padding: ${({ theme }) => theme.space[16]} 0;

  ${mq.desktop} {
    padding: 0;
  }
`;

interface SupportCenterProps {
  isSeller: boolean;
  trackingExtras: {
    seller_type: 'seller' | 'buyer';
    ad_id: number;
    seller_id: string;
  };
}

const SupportCenter = ({ trackingExtras }: SupportCenterProps) => (
  <SupportCenterContainer data-cy="returns-details-help-center">
    <SupportCardContent
      createTicketUrl={EXTERNAL_LINKS.CREATE_REQUEST}
      trackingExtras={trackingExtras}
      tab={TAB_TYPE_CLAIMS_AND_RETURNS}
    />
  </SupportCenterContainer>
);

export default SupportCenter;
